<template>
  <v-container>
    <h1 class="text-center my-6">Últimas Noticias de Tecnología</h1>
    <v-row>
      <v-col cols="12" md="4" v-for="item in articles" :key="item.url">
        <v-card outlined class="mx-auto" max-width="400">
          <v-img
            :src="item.urlToImage || 'https://picsum.photos/600/300'"
            height="200px"
          />
          <v-card-title class="headline">{{ item.title }}</v-card-title>
          <v-card-subtitle>
            {{ new Date(item.publishedAt).toLocaleDateString() }}
          </v-card-subtitle>
          <v-card-text>{{ item.description }}</v-card-text>
          <v-card-actions>
            <v-btn color="primary" text :href="item.url" target="_blank">
              Leer más
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "BlogNotice",
  data() {
    return {
      articles: [],
    };
  },
  created() {
    this.fetchArticles();
  },
  methods: {
    async fetchArticles() {
      try {
        const res = await axios.get(
          "https://gnews.io/api/v4/top-headlines?category=technology&lang=es&country=es&max=9&apikey=demo"
        );
        this.articles = res.data.articles.map((art) => ({
          title: art.title,
          url: art.url,
          description: art.description,
          publishedAt: art.publishedAt,
          urlToImage: art.image,
        }));
      } catch (error) {
        console.error("Error al cargar noticias", error);
      }
    },
  },
};
</script>
